import type { UserInfoBusiness } from '@moniebook-web/types';
import { defaultObjectSort } from '@moniebook-web/utils';

type BusinessInformation = Pick<
    UserInfoBusiness,
    'id' | 'name' | 'numberOfBranches'
>;

export const sortedBusinessesBySelected = (
    businesses: BusinessInformation[] | null,
    currentBusiness: UserInfoBusiness | null,
) => {
    if (!businesses) {
        return [];
    }

    const nonSelectedBusinesses =
        businesses?.filter((business) => business.id !== currentBusiness?.id) ||
        [];

    const sortedBusinesses =
        [...nonSelectedBusinesses].sort(defaultObjectSort('name')) || [];

    if (currentBusiness) {
        sortedBusinesses.unshift(currentBusiness);
    }

    return sortedBusinesses.map((business) => ({
        id: business.id,
        name: business.name,
        branchesCount: business.numberOfBranches,
        isCurrent: business.id === currentBusiness?.id,
    }));
};
